import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Icon } from "antd";
import styled from "react-emotion";

import UploadModal from "./UploadModal";
import * as actions from "../../../actions";

// --------------------------- Styles --------------

const CardWrapper = styled("div")({
  marginBottom: "30px"
});

const Header = styled("span")({
  fontSize: "12px",
  color: "#5a5353",
  textAlign: "left",
  marginBottom: "5px"
});
const ButtonWrapper = styled("div")({
  width: "85%",
  margin: "auto",
  button: {
    width: "100%",
    background: "#0000009e",
    color: "#fff"
  }
});
// -------------------------------------------------
class Upload extends Component {
  showModal = () => {
    this.props.showUploadModal({ showModal: true, loading: false });
  };

  handleOk = () => {};

  handleCancel = () => {
    this.props.showUploadModal({ showModal: false, loading: false });
  };

  render() {
    const { uploadModalVisibility } = this.props;
    return (
      <CardWrapper>
        <ButtonWrapper>
          <Header>Add at least 1 image and 1 logo</Header>
          <Button onClick={this.showModal}>
            <Icon type="plus" />
            Images & Logos
          </Button>
          {uploadModalVisibility ? (
            <UploadModal onOk={this.handleOk} onCancel={this.handleCancel} />
          ) : null}
        </ButtonWrapper>
      </CardWrapper>
    );
  }
}

const mapStateToProps = state => ({
  uploadModalVisibility: state.loadingInfo.showModal
});

export default connect(
  mapStateToProps,
  actions
)(Upload);
